import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const EmailMarketing = () => {
  const relatedBlogs = [
    {
      id: 5,
      title: 'The Complete Guide to Google Ads for Healthcare Providers',
      image: '/images/Blog6.png',
      date: 'January 20, 2026'
    },
    {
      id: 3,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      image: '/images/Blog2.png',
      date: 'January 28, 2026'
    },
    {
      id: 7,
      title: 'Patient Acquisition Strategies That Work in 2026',
      image: '/images/Blog9.png',
      date: 'February 1, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Email Marketing for Healthcare
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Email Marketing
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                Email Marketing for Healthcare: Build Patient Loyalty and Retention
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : January 12, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : January 12, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Email marketing remains one of the most effective channels for healthcare providers to maintain patient relationships, increase appointment bookings, and improve patient retention. With an average ROI of $42 for every dollar spent, email marketing offers medical practices a cost-effective way to stay connected with patients while delivering personalized health information and practice updates.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                 This comprehensive guide covers everything medical practices need to know about healthcare email marketing, from building compliant email lists and creating engaging campaigns to automation strategies and measuring performance. Learn how to leverage email marketing while maintaining HIPAA compliance and professional healthcare standards.
                </p>

                 <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                 Effective email marketing allows healthcare providers to stay connected with patients beyond clinic visits by sharing appointment reminders, wellness tips, treatment updates, and educational resources. When executed thoughtfully, these campaigns strengthen patient trust, improve communication, and encourage long-term engagement without overwhelming recipients.
               </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                By combining personalized messaging with data-driven insights, medical practices can optimize open rates, improve patient response, and streamline follow-up processes. A well-planned email strategy not only supports patient retention and satisfaction but also contributes to sustainable practice growth in an increasingly digital healthcare environment.
               </p>

              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Digital Marketing', 'Patient Acquisition', 'Content Marketing', 'Healthcare Technology', 'SEO', 'Social Media', 'Web Development', 'Online Reputation Management'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help with Email Marketing?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert email marketing strategies designed for healthcare practices.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              The Power of Email Marketing for Medical Practices
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Email marketing provides medical practices with direct communication channels to patients, allowing personalized messaging, appointment reminders, health education, and practice updates. Unlike social media where algorithms control visibility, email delivers messages directly to patient inboxes, ensuring your communications reach intended recipients.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              In 2026, sophisticated email marketing platforms offer automation, segmentation, personalization, and analytics capabilities that make healthcare email campaigns more effective than ever. Practices that master email marketing enjoy higher patient retention rates, increased appointment bookings, better patient compliance, and stronger relationships with their patient base.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Building HIPAA-Compliant Email Lists
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Build email lists through legitimate opt-in methods including website signup forms, patient portal registrations, appointment booking confirmations, and in-office signup sheets. Never purchase email lists or add patients without explicit consent. Implement double opt-in processes to ensure email address validity and genuine interest in receiving communications.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Maintain HIPAA compliance by using encrypted email platforms, securing patient data, obtaining proper authorization for health information communications, and providing clear opt-out mechanisms. Segment email lists by patient demographics, visit history, health interests, and engagement levels to deliver more relevant, personalized communications.
            </p>

            <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-4 mt-6">
              Email List Building Strategies
            </h3>

            <ul className="list-disc list-inside text-gray-900 text-base leading-relaxed mb-6 space-y-2 ml-4 text-justify">
              <li>Website popup forms with compelling value propositions</li>
              <li>Downloadable health guides and resources</li>
              <li>Appointment booking confirmation opt-ins</li>
              <li>Patient portal registration integration</li>
              <li>In-office signup forms at reception desks</li>
              <li>Social media lead generation campaigns</li>
            </ul>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Creating Engaging Email Campaigns
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Develop email campaigns that provide value, educate patients, and encourage action. Create monthly newsletters with health tips, practice updates, and seasonal wellness advice. Send appointment reminders, follow-up care instructions, preventive care recommendations, and birthday wishes. Balance promotional content with educational information that builds trust and demonstrates expertise.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Write compelling subject lines that encourage opens without being misleading or sensational. Personalize emails with patient names, relevant health information, and tailored recommendations. Include clear calls-to-action directing recipients to book appointments, read blog posts, follow social media accounts, or contact the practice with questions.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Email Automation for Healthcare
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Implement automated email sequences that save time while maintaining personal touch. Create welcome series for new patients introducing practice services, team members, and communication preferences. Set up appointment reminder sequences, post-visit follow-ups, birthday greetings, annual checkup reminders, and re-engagement campaigns for inactive patients.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Develop triggered campaigns based on patient actions including appointment bookings, form submissions, website visits, and email engagement. Automation ensures timely, relevant communications while freeing staff to focus on patient care. Monitor automated campaigns regularly to maintain relevance and effectiveness.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Email Design Best Practices
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Design mobile-responsive emails that display correctly on all devices, with 60% of emails opened on smartphones in 2026. Use clean, professional layouts with clear hierarchy, readable fonts, and appropriate white space. Include practice branding, professional photos, and visual elements that enhance readability without overwhelming content.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Keep emails concise and focused on single topics or calls-to-action. Use short paragraphs, bullet points, and strategic formatting to improve scannability. Test emails across different email clients and devices before sending. Include accessible alt text for images and ensure content remains readable even if images don't load.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Personalization and Segmentation
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Segment email lists based on patient demographics, health conditions, visit history, engagement levels, and interests. Send targeted campaigns addressing specific patient needs and concerns. Personalize content beyond names—reference previous appointments, recommend relevant services, and provide information matching patient health profiles.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Create patient journey email sequences that deliver appropriate content at different stages. New patients receive orientation information, established patients get wellness tips and service recommendations, and inactive patients receive re-engagement offers. Personalization increases open rates, click-through rates, and conversion while strengthening patient relationships.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Measuring Email Marketing Performance
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Track key metrics including open rates, click-through rates, conversion rates, unsubscribe rates, and email-driven appointment bookings. Monitor which email types generate highest engagement, identify optimal send times, and understand what content resonates with different patient segments. Use A/B testing to optimize subject lines, content, calls-to-action, and sending schedules.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Analyze campaign performance regularly, document successful strategies, and continuously refine your approach based on data insights. Successful email marketing requires ongoing optimization, testing, and adaptation to changing patient preferences and behaviors. Combine quantitative metrics with qualitative feedback to improve campaign effectiveness.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How often should medical practices send emails?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Send monthly newsletters and periodic educational emails (2-4 times per month). Automated appointment reminders and follow-ups should be sent as needed. Avoid over-emailing which leads to unsubscribes. Find the balance that keeps your practice top-of-mind without overwhelming patients.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Is email marketing HIPAA compliant?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Yes, when properly implemented. Use HIPAA-compliant email platforms with encryption, secure patient data, obtain authorization for health information communications, and never include protected health information in unsecured emails. General marketing emails don't require HIPAA compliance, but patient-specific health communications do.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What email content works best for healthcare?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Educational health tips, seasonal wellness advice, practice updates, new service announcements, patient success stories (with consent), preventive care reminders, and relevant health news perform well. Balance promotional content with valuable information that helps patients maintain their health.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What's a good open rate for healthcare emails?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Healthcare email open rates average 20-25%, with click-through rates around 2-3%. Rates vary by list quality, content relevance, and audience engagement. Well-segmented, personalized campaigns often achieve higher rates. Focus on improving performance over time rather than comparing to industry averages.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with email marketing?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare email marketing with proven strategies for medical practices. We handle list building, campaign creation, automation setup, HIPAA-compliant platform configuration, content writing, design, and performance tracking. Our healthcare expertise ensures effective, compliant email marketing that drives results.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to="/blog"
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EmailMarketing;